import type { ObbTakeoffData } from './obbTakeoff';

// Kitchen cabinet wall takeoff for the Kimbark Residence.
// Source: SI extraction. Coordinates: raw scene Z-up.
// world_x=raw_x, world_y=raw_z, world_z=-raw_y.
// P0-P3 bottom (raw_z≈-1.45), P4-P7 top (raw_z≈1.14). Pi↔P(i+4) verticals.
// Long axis P0→P2 (11'9"), short axis P0→P1 (2'5"), height (8'6").

const P: [number, number, number][] = [
  [2.798889, -8.804105, -1.448579],  // P0 bottom
  [3.479450, -9.056792, -1.448579],  // P1 bottom
  [4.049529, -5.435767, -1.448579],  // P2 bottom
  [4.730090, -5.688454, -1.448579],  // P3 bottom
  [2.798889, -8.804105,  1.142526],  // P4 top
  [3.479450, -9.056792,  1.142526],  // P5 top
  [4.049529, -5.435767,  1.142526],  // P6 top
  [4.730090, -5.688454,  1.142526],  // P7 top
];

const mid = (a: [number,number,number], b: [number,number,number]): [number,number,number] =>
  [(a[0]+b[0])/2, (a[1]+b[1])/2, (a[2]+b[2])/2];

const off = (p: [number,number,number], d: [number,number,number]): [number,number,number] =>
  [p[0]+d[0], p[1]+d[1], p[2]+d[2]];

// Short axis (P0→P1): (0.681, -0.253, 0) normalised × 0.3m
const SA: [number,number,number] = [0.281, -0.104, 0];
// Long axis (P0→P2): (1.251, 3.368, 0) normalised × 0.3m
const LA: [number,number,number] = [0.104, 0.281, 0];

export const KIMBARK_CABINET_TAKEOFF: ObbTakeoffData = {
  title:             'Kitchen Takeoff',
  subtitle:          'Ground Floor',
  elementLabel:      'Cabinet Wall',
  elementDimensions: "11' 9\" × 2' 5\" × 8' 6\"",
  scanLabel:         'Scan 5',
  color:             '#34d399',  // emerald

  obbPoints: P,

  dimensionAnchors: {
    a: { point: off(mid(P[0], P[2]), SA), label: "11' 9\"" },  // long side
    b: { point: off(mid(P[0], P[1]), LA), label: "2' 5\"" },   // short side
    c: { point: off(mid(P[0], P[4]), [-0.2, 0, 0]), label: "8' 6\"" }, // height
  },

  cameraPos:    [-1.452, 0.266, 3.583],
  cameraLookAt: [3.764, -0.153, 7.246],

  items: [
    { label: 'Cabinet panels', modelQty: 1, unit: 'set', wastePercent: 0 },
  ],
};
